import { ApiService } from "../api";
import { Form } from "./Form";

export class FormService {
	protected apiService: ApiService;

	constructor() {
		this.apiService = new ApiService();
	}

	public async findAll(): Promise<Form[]> {
		const formData = await this.apiService.get("/api/v1/forms");
		const forms = await formData.json();

		return Form.fromJsonArray(forms);
	}

	public async save(form: Form): Promise<Form> {
		const formData = await this.apiService.post(
			`/api/v1/form/${form.id}`,
			form,
		);
		const updatedForm = await formData.json();
		return Form.fromJson(updatedForm);
	}

	public async create(form: Form): Promise<Form> {
		const formData = await this.apiService.post(`/api/v1/forms`, form);
		const newForm = await formData.json();
		return Form.fromJson(newForm);
	}
}
